export interface FeatureFlags {
  /**
   * @description This flag is used to control the release of checkout step summaries with cart item names
   * @example false - hide cart item names when rendering checkout step summaries
   * @example true - show cart item names when rendering checkout step summaries
   * https://sparknz.atlassian.net/wiki/spaces/DC/pages/11697324287/Release+Enable+Enhanced+Checkout+Step+Summary
   */
  'release-enable-enhanced-checkout-step-summary': boolean;
}

const initalizeFlags: FeatureFlags = {
  'release-enable-enhanced-checkout-step-summary': false,
};

const flagsWithLocalOverride =
  process.env.NODE_ENV === 'development'
    ? {
        'release-enable-enhanced-checkout-step-summary': true,
      }
    : {};

const defaultFlags = {
  ...initalizeFlags,
  ...flagsWithLocalOverride,
};

export { defaultFlags };
